import { useUser } from "../../contexts/UserContext";
import { FaCoins } from "react-icons/fa6";

import "./CoinDisplay.css";

export default function CoinDisplay() {
    // Can't display coins without getting the coins.
    const coins = useUser()?.coins;

    // Show the coins with a coin icon.
    return (
        <div className="coin-display-container">
            <FaCoins />
            <span
                style={{
                    margin: "auto 0.5em",
                    pointerEvents: "none",
                    fontSize: "20px",
                }}
            >
                {coins ?? 0}
            </span>
        </div>
    );
}
